<div class="dialog-header">
  <div class="header-title">
    <span class="header-span">{{headerTitle}}</span>
  </div>
  <button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content" *ngIf="!typeLoading">
  <div class="inputs-block">
    <div class="input-block">
      <div class="input-label">Name:</div>

      <div class="email-input-text">
        <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation
               [ngModelOptions]="{standalone: true}" [(ngModel)]="tempPricingMultiplication.name">
      </div>
    </div>

    <div class="input-block">
      <div class="input-label">Apply To Field:</div>

      <div class="email-input-text">
        <p-dropdown [options]="applyToFields" [(ngModel)]="tempPricingMultiplication.applyToField"
                    placeholder="Apply To Field" appendTo="body" panelStyleClass="p-modifier-dropdown-panel">

        </p-dropdown>
      </div>
    </div>
    <div class="input-block">
      <div class="input-label">Operation:</div>

      <div class="email-input-text">
        <p-dropdown [options]="operations" [(ngModel)]="tempPricingMultiplication.operation"
                    placeholder="Operation" appendTo="body" panelStyleClass="p-modifier-dropdown-panel">
        </p-dropdown>
      </div>
    </div>
    <div class="input-block">
      <div class="input-label">Value:</div>

      <div class="email-input-text">
        <p-inputNumber class="arrow-input value-input-number"
                       [ngModelOptions]="{standalone: true}"
                       [(ngModel)]="tempPricingMultiplication.value" mode="decimal" [minFractionDigits]="1"
                       [maxFractionDigits]="2"></p-inputNumber>
      </div>
    </div>

    <div class="input-block">
      <div class="input-label">Categories:</div>

      <div class="email-input-text">
        <p-listbox [options]="categories" [(ngModel)]="tempPricingMultiplication.categories" [multiple]="true"
                   [checkbox]="true"
                   [showToggleAll]="true" optionLabel="name" [filter]="true"
                   [ngModelOptions]="{standalone: true}" class="p-list-box-block">
        </p-listbox>
      </div>
    </div>
  </div>

  <div class="save-btn-block">
    <div class="sav-btn-bloock">
      <div class="space-block">
      </div>

      <button mat-button class="save-btn" (click)="saveSub()"
              [disabled]="loadingSpinner || !tempPricingMultiplication.name"
              tabindex="1" type="submit"
              [ngClass]="{'disabled-button': loadingSpinner || !tempPricingMultiplication.name}">

        <span *ngIf="!loadingSpinner">{{footerBtnString}}</span>
        <lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
      </button>

      <div class="flex-box">
        <button *ngIf="footerBtnString === 'Save'" mat-button class="delete-task-button" (click)="deleteSub()">
          <mat-icon *ngIf="!deleteLoadingSpinner">delete</mat-icon>
          <lib-mini-progress-spinner *ngIf="deleteLoadingSpinner"></lib-mini-progress-spinner>
        </button>
      </div>

    </div>
  </div>
</div>
<div class="loading-spinner-block" *ngIf="typeLoading">
  <lib-progress-spinner></lib-progress-spinner>
</div>
